import {gql} from "apollo-boost";

export const RecoverPasswordQuery = gql`
    query RecoverPassword($email:String!){
        recoveryPassword(email: {email: $email}) {
            statusCode
            message
        }
    }
`;